<template>
  <nav class="sidebar sidebar-offcanvas" id="sidebar">
    <ul class="nav">
      <li class="nav-item">
        <router-link class="nav-link" to="/get-started">
          <i class="fa fa-solid fa-list-alt menu-icon" style="margin-right: 6px"></i>
          <span class="menu-title">Get Started</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/create-app">
          <i class="fa fa-solid fa-mobile-screen-button menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">Create App</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="isAdmin==false">
        <router-link class="nav-link" to="/app-list">
          <i class="fa fa-solid fa-mobile-retro menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">My USSD Apps</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/custom-functions">
          <i class="fa fa-solid fa-mobile-retro menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">My Custom Actions</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/api-keys">
          <i class="fa fa-solid fa-key menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">CLI API Keys</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="isAdmin">
        <router-link class="nav-link" to="/app-list-admin">
          <i class="fa fa-solid fa-mobile-retro menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">USSD Apps</span>
        </router-link>
      </li>

      <!-- Merchant Management Section -->
      <li class="nav-item"  v-if="isAdmin">
        <a class="nav-link" data-bs-toggle="collapse" href="#merchant-management" aria-expanded="false" aria-controls="merchant-management">
          <i class="fa fa-solid fa-store menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">Merchant Management</span>
          <i class="menu-arrow"></i>
        </a>
        <div class="collapse" id="merchant-management">
          <ul class="nav flex-column sub-menu">
            <li class="nav-item">
              <router-link class="nav-link" to="/merchant/list">
                <span class="menu-title">All Merchants</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/merchant/my-merchants">
                <span class="menu-title">My Merchants</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/merchant/register">
                <span class="menu-title">Register Merchant</span>
              </router-link>
            </li>
          </ul>
        </div>
      </li>

      <!-- User Management Section -->
      <li class="nav-item"  v-if="isSuperAdmin">
        <a class="nav-link" data-bs-toggle="collapse" href="#user-management" aria-expanded="false" aria-controls="user-management">
          <i class="fa fa-solid fa-users menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">User Management</span>
          <i class="menu-arrow"></i>
        </a>
        <div class="collapse" id="user-management">
          <ul class="nav flex-column sub-menu">
            <li class="nav-item">
              <router-link class="nav-link" to="/admin/list">
                <span class="menu-title">All Users</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/admin/create">
                <span class="menu-title">Create Admin</span>
              </router-link>
            </li>
          </ul>
        </div>
      </li>

       
      <li class="nav-item"  v-if="isAdmin || isChatBotUser">
        <router-link class="nav-link" to="/whatsapp-bots">
          <i class="fa fa-brands fa-whatsapp menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">WhatsApp Bots</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/app-templates">
          <i class="fa fa-solid fa-magnifying-glass-arrow-right menu-icon" style="margin-right: 6px"></i>
          <span class="menu-title">Templates</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/buy-shortcode">
          <i class="fa fa-solid fa-mobile-screen-button menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">Buy USSD ShortCode</span>
        </router-link>
      </li>

      <li class="nav-item" v-if="isAdmin">
        <router-link class="nav-link" to="/shortcode-providers">
          <i class="fa fa-solid fa-building menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">ShortCode Providers</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="isAdmin">
        <router-link class="nav-link" to="/provision-shortcode">
          <i class="fa fa-solid fa-mobile-screen-button menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">Available USSD Extensions</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/my-shortcodes">
          <i class="fa fa-solid fa-mobile-screen-button menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">My USSD Extensions</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="isMerchant">
        <router-link class="nav-link" to="/merchant/manage-account">
          <i class="fa fa-solid fa-cog menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">Manage Merchant Account</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="isMerchant">
        <router-link class="nav-link" to="/merchant/trxns">
          <i class="fa fa-solid fa-money-bill menu-icon" style="margin-right: 10px"></i>
          <span class="menu-title">Merchant Transactions</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/account-billing">
          <i class="fa fa-solid fa-money-bill menu-icon" style="margin-right: 6px"></i>
          <span class="menu-title">Account Billing</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isAdmin: false,
      isSuperAdmin: false,
      isChatBotUser: false,
      isMerchant: false,
      userType: "private_user"
    };
  },
  mounted() {
    this.checkAdminStatus();
  },
  methods: {
    checkAdminStatus() {
      const userRole = localStorage.getItem("userRole");
      let userType = localStorage.getItem("userType") || "private_user";
      if(userType == "internal_admin"){
        this.isAdmin = true;
      }else{
        this.isAdmin = (userRole && userRole.toUpperCase() === 'ADMIN');
      }
      this.userType = userType;
      const roles = JSON.parse(localStorage.getItem("roles")) || [];
      this.isSuperAdmin = this.isAdmin && roles.includes("super_admin");
      this.isChatBotUser =(userRole && userRole.toUpperCase() === 'CHATBOT');
      if(userType == "merchant"){
        this.isMerchant = true;
      }
     }
  },
};
</script>
